export const keyCodes = {
  TAB: "Tab",
  DOWN: "ArrowDown",
  UP: "ArrowUp",
  SHIFT: "Shift",
  SPACE: " ",
  ESCAPE: "Escape",
  ENTER: "Enter"
};